import { skipToken, useQuery } from '@tanstack/react-query';

import { type FontMetadata, FontMetadataSchema } from '~/components/v2/schemas/context-sources/fontMetadataSchema';

const PRIVATE_FONT_METADATA_KEY = 'PRIVATE_FONT_METADATA';

export type FontMetadataParams = {
  metadataUrl: string | undefined;
};

export type FontMetadataKey = [typeof PRIVATE_FONT_METADATA_KEY, FontMetadataParams];

export const getFontMetadataKey = (params: FontMetadataParams): FontMetadataKey => {
  return [PRIVATE_FONT_METADATA_KEY, params];
};

export type UseFontMetadataOptions = {
  enabled?: boolean;
};

export const useFontMetadata = (params: FontMetadataParams, options?: UseFontMetadataOptions) => {
  const { metadataUrl } = params;

  return useQuery({
    enabled: !!metadataUrl && (options?.enabled ?? true),
    queryFn: metadataUrl
      ? async (): Promise<FontMetadata> => {
          const res = await fetch(metadataUrl);

          if (!res.ok) {
            throw new Error('Failed to fetch font metadata');
          }

          return FontMetadataSchema.parse(await res.json());
        }
      : skipToken,
    queryKey: getFontMetadataKey(params),
    staleTime: Infinity,
  });
};
